import { defineMessages } from 'react-intl';

export const salesOpeningTableScope = 'app.components.salesOpeningTable';

export const salesOpeningTableMessages = {
  heading: {
    id: `${salesOpeningTableScope}.heading`,
    defaultMessage: "Calendrier d'ouverture des ventes par transporteur",
    en: 'Ticket sales opening calendar by carrier',
    it: 'Calendario di apertura delle vendite per vettore',
    es: 'Calendario de apertura de ventas por transportista',
    de: 'Verkaufsstart-Kalender nach Anbieter',
    nl: 'Verkoopstartkalender per vervoerder',
  },
  statusUpcoming: {
    id: `${salesOpeningTableScope}.statusUpcoming`,
    defaultMessage: 'À venir',
    en: 'Upcoming',
    it: 'In arrivo',
    es: 'Próximamente',
    de: 'Demnächst',
    nl: 'Binnenkort',
  },
  statusOpen: {
    id: `${salesOpeningTableScope}.statusOpen`,
    defaultMessage: 'En vente',
    en: 'On sale',
    it: 'In vendita',
    es: 'A la venta',
    de: 'Im Verkauf',
    nl: 'In de verkoop',
  },
  parisTime: {
    id: `${salesOpeningTableScope}.parisTime`,
    defaultMessage: 'heure de Paris',
    en: 'Paris time',
    it: 'ora di Parigi',
    es: 'hora de París',
    de: 'Pariser Zeit',
    nl: 'Parijse tijd',
  },
  alreadyOpenTitle: {
    id: `${salesOpeningTableScope}.alreadyOpenTitle`,
    defaultMessage:
      'Déjà en vente ({count, plural, one {# ouverture} other {# ouvertures}})',
    en: 'Already on sale ({count, plural, one {# opening} other {# openings}})',
    it: 'Già in vendita ({count, plural, one {# apertura} other {# aperture}})',
    es: 'Ya a la venta ({count, plural, one {# apertura} other {# aperturas}})',
    de: 'Bereits im Verkauf ({count, plural, one {# Verkaufsstart} other {# Verkaufsstarts}})',
    nl: 'Al in de verkoop ({count, plural, one {# verkoopstart} other {# verkoopstarts}})',
  },
  familyAll: {
    id: `${salesOpeningTableScope}.familyAll`,
    defaultMessage: '{family} (toutes destinations)',
    en: '{family} (all destinations)',
    it: '{family} (tutte le destinazioni)',
    es: '{family} (todos los destinos)',
    de: '{family} (alle Ziele)',
    nl: '{family} (alle bestemmingen)',
  },
  dateRange: {
    id: `${salesOpeningTableScope}.dateRange`,
    defaultMessage: 'Du {from} au {to}',
    en: 'From {from} to {to}',
    it: 'Dal {from} al {to}',
    es: 'Del {from} al {to}',
    de: 'Vom {from} bis {to}',
    nl: 'Van {from} tot {to}',
  },
  fromDate: {
    id: `${salesOpeningTableScope}.fromDate`,
    defaultMessage: 'À partir du {from}',
    en: 'From {from}',
    it: 'A partire dal {from}',
    es: 'A partir del {from}',
    de: 'Ab {from}',
    nl: 'Vanaf {from}',
  },
};

export default defineMessages(salesOpeningTableMessages);
